import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Input, Select, InputNumber, Row, Col } from "antd";
import styled from "@emotion/styled";
import { TopBar } from "screens/employer/create-employer/top-bar";
import {
  changeArrayToStringInObject,
  useDebounce,
  useDocumentTitle,
} from "utils";

import { District } from "components/district";
import { AdminSelect } from "components/admin-select";
import { Profiler } from "components/profiler";
import { useAddEmployer } from "../../../../utils/employer";
import PageContainer from "../../../../components/layout/PageContainer";

export const CreateCompanyEmployerScreen = () => {
  useDocumentTitle("creation of residential care homes/corporate employer", false);
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const { mutate, isLoading, isError, isSuccess, data } = useAddEmployer();

  useEffect(() => {
    if (isSuccess && data) {
      // @ts-ignore
      navigate(`/employer/${data?.uuid}`);
    }
  }, [isSuccess]);

  const onSubmit = async (values?: any) => {
    await mutate(changeArrayToStringInObject(values));
  };

  return (
    <Profiler id="creation of residential care homes/corporate employer">
      <PageContainer>
        <Form
          form={form}
          layout="vertical"
          onFinish={onSubmit}
          initialValues={{ type: 1 }}
        >
          <TopBar title="creation of residential care homes/corporate employer" isLoading={isLoading} />
          <Form.Item name="type" hidden>
            <Input />
          </Form.Item>
          <ContentContainer>
            <FormCard>
              <CardTitle>employer information</CardTitle>
              <Row gutter={[16, 4]}>
                <Col span={12}>
                  <Form.Item
                    name="companyName"
                    label="company name"
                    rules={[{ required: true, message: "please enter your company name" }]}
                  >
                    <Input placeholder="company name" />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="contactPerson"
                    label="name of person in charge"
                    rules={[{ required: true, message: "please enter the name of the person in charge" }]}
                  >
                    <Input placeholder="name of person in charge" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name="contactPersonPosition" label="rank of person in charge">
                    <Input placeholder="rank of person in charge" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name="code" label="community voucher number">
                    <Input placeholder="community voucher number" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name="codePercentage" label="community voucher percentage">
                    <InputNumber
                      placeholder="community voucher percentage"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </FormCard>

            <FormCard>
              <CardTitle>contact information</CardTitle>
              <Row gutter={[16, 4]}>
                <Col span={12}>
                  <Form.Item
                    name="contactNumber"
                    label="contact number"
                    rules={[{ required: true, message: "please enter your company name" }]}
                  >
                    <Input placeholder="contact number" />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item name="email" label="email">
                    <Input placeholder="email" />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="district"
                    label="regions served"
                    rules={[{ required: true, message: "please select a service region" }]}
                  >
                    <District />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="address"
                    label="full service address"
                    rules={[{ required: true, message: "please enter the full service address" }]}
                  >
                    <Input placeholder="full service address" />
                  </Form.Item>
                </Col>
              </Row>
            </FormCard>

            <FormCard>
              <CardTitle>UniCare remark</CardTitle>
              <Row gutter={[16, 4]}>
                <Col span={12}>
                  <Form.Item
                    name="personInCharge"
                    label="responsible for employees"
                    rules={[{ required: true, message: "please select the person in charge" }]}
                  >
                    <AdminSelect placeholder="responsible for employees" />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item name="remark" label="remark">
                    <Input.TextArea
                      placeholder="remark"
                      autoSize={{ minRows: 2, maxRows: 6 }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </FormCard>
          </ContentContainer>
        </Form>
      </PageContainer>
    </Profiler>
  );
};

const ContentContainer = styled.div`
  padding: 3.2rem;
`;

const FormCard = styled.div`
  padding: 2.4rem;
  background-color: #ffffff;
  margin-bottom: 2.4rem;
`;

const CardTitle = styled.div`
  color: #3c3e42;
  font-size: 20px;
  font-weight: bold;
  padding-bottom: 10px;
`;

const InputLabel = styled.div`
  color: #3c3e42;
  font-size: 20px;
  font-weight: bold;
`;

CreateCompanyEmployerScreen.whyDidYouRender = false;
